import { pdf } from '@react-pdf/renderer';
import PosInvoicePdfV2 from '../../pos/components/subcomponents/posInvoicePdfV2';
import { handleNumber, utcMoment } from '../../../../utils/common';
import { toast } from 'react-toastify';
import React from 'react';

export const handleRePrint = async (data, selectedLocation, isKOT = false) => {
  const paymentsWithAmounts = (data?.pos_payments || [])
    ?.filter((value) => value?.amount > 0)
    ?.map((value) => ({ name: value?.paymentTypesName, amount: Number(value?.amount || 0), code: value?.paymentTypesCode }));
  const pdfBlob = await pdf(
    <PosInvoicePdfV2
      data={{
        selectedPrinter: data?.selectedPrinter || 'epson',
        billPaddingLeftMm: data?.billPaddingLeftMm ?? selectedLocation?.billPaddingLeftMm ?? localStorage.getItem('billPaddingLeftMm'),
        billPaddingRightMm: data?.billPaddingRightMm ?? selectedLocation?.billPaddingRightMm ?? localStorage.getItem('billPaddingRightMm'),
        isReprint: true,
        isKOT: isKOT,
        locationName: selectedLocation?.invoiceName,
        locationAddress: selectedLocation?.address,
        phoneNumber: selectedLocation?.contactNumber,
        orderNumber: data?.pos_id,
        orderType: data?.pos_saleTypeName,
        cashierName: data?.pos_entered_userName,
        cashierDrawerId: data?.cashdrawers_id,
        customerName: data?.customerName,
        loyaltyPoint: data?.pos_payments?.find((v) => v?.paymentTypesCode === 'LOYALTY_POINTS' && v?.amount > 0)?.amount || null,
        tableNumber: data?.tableNumber || '-',
        specialNote: data?.specialNote || '-',
        dateTime: utcMoment(data?.pos_dateTime).format('YYYY-MM-DD HH:mm:ss'),
        invoiceItems: data?.pos_items.map((item) => {
          return {
            title: item.foodName,
            qty: handleNumber(item.qty),
            price: handleNumber(item.itemPrice),
            amount: item.qtyPrice,
          };
        }),
        grandTotal: data?.pos_totalAmount || 0,
        givenAmount: data?.pos_totalPaidAmount || 0,
        balanceAmount: data?.pos_balance || 0,
        payments: paymentsWithAmounts,
        totalItemCount: data?.pos_items?.length || 0,
      }}
    />
  ).toBlob();

  // const url = window.URL.createObjectURL(pdfBlob);
  // const link = document.createElement('a');
  // link.href = url;
  // link.download = isKOT ? 'KOT.pdf' : 'Invoice.pdf';
  // document.body.appendChild(link);
  // link.click();
  // link.remove();
  sendPDFToBackend(pdfBlob, isKOT ? 'ReprintKOT' : 'ReprintInvoice');
};

const sendPDFToBackend = (blob, name) => {
  const formdata = new FormData();
  formdata.append('pdfFile', blob, `${name}.pdf`);
  formdata.append('pageCount', '1');

  const requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow',
  };

  fetch('http://localhost:3001/print', requestOptions)
    .then((response) => response.text())
    .then((result) => {
      toast.success('Invoice Printed Successfully!');
    })
    .catch((error) => {
      console.error('Error sending PDF:', error);
      toast.error('Error Printing Invoice!');
    });
};
